import { render } from "./EventParticipants.vue?vue&type=template&id=451604a7"
import script from "./EventParticipants.vue?vue&type=script&lang=js"
export * from "./EventParticipants.vue?vue&type=script&lang=js"

import "./EventParticipants.vue?vue&type=style&index=0&id=451604a7&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__